<template>
  <div class="container">
    <template>
      <div class="addRoute">
        <div class="addRoute__header">
          <h1 class="medium-title">{{ routeId ? `Edit` : `Add New` + ` Location` }}</h1>
        </div>
        <div v-if="!isLoadingAll" class="addRoute__body">
          <!-- Left Content -->
          <div class="addRoute__body__left">
            <div class="addRoute__body__left__form">
              <!-- Basic Information -->
              <div class="addRoute__body__left__form__container">
                <h1 class="subhead">Basic Information</h1>
                <div class="addRoute__body__left__form__container__item">
                  <a-input
                    :label="`Code`"
                    :value.sync="model.code"
                    :error.sync="vuelidateOptions.code.error"
                    :ref="vuelidateOptions.code.ref"
                  />
                </div>
                <div class="addRoute__body__left__form__container__item">
                  <a-input
                    :label="`Name`"
                    :value.sync="model.name"
                    :error.sync="vuelidateOptions.name.error"
                    :ref="vuelidateOptions.name.ref"
                  />
                </div>
                <div class="addRoute__body__left__form__container__item--flex">
                  <a-select-dropdown
                    :label="`Categories`"
                    :options="options.categories"
                    :value.sync="model.categoryId"
                    :error.sync="vuelidateOptions.categoryId.error"
                    @addNew="toggleModal('category')"
                    :insertAddNew="false"
                    :ref="vuelidateOptions.categoryId.ref"
                  />
                  <a-select-dropdown
                    :label="`Vendor / Brand`"
                    :options="options.brands"
                    :value.sync="model.brandId"
                    :error.sync="vuelidateOptions.brandId.error"
                    @addNew="toggleModal('brand')"
                    :insertAddNew="`true`"
                    :ref="vuelidateOptions.brandId.ref"
                  />
                  <a-input
                    :label="`Side (Optional)`"
                    :value.sync="model.side"
                    :error.sync="vuelidateOptions.side.error"
                    :ref="vuelidateOptions.side.ref"
                  />
                </div>
                <div class="addRoute__body__left__form__container__item">
                  <a-textarea
                    :label="`Description ( Optional )`"
                    :value.sync="model.description"
                    :error.sync="vuelidateOptions.description.error"
                    :ref="vuelidateOptions.description.ref"
                  />
                </div>
              </div>
              <!-- Location Details -->
              <div class="addRoute__body__left__form__container">
                <h1 class="subhead">Location Details</h1>
                <div class="addRoute__body__left__form__container__item">
                  <a-textarea
                    :label="`Address`"
                    :value.sync="model.address"
                    :error.sync="vuelidateOptions.address.error"
                    :ref="vuelidateOptions.address.ref"
                  />
                </div>
                <div class="addRoute__body__left__form__container__item--flex">
                  <div class="addRoute__body__left__form__container__item">
                    <a-select-dropdown
                      :label="`Province`"
                      :options="options.provinces"
                      :value.sync="model.provinceId"
                      :error.sync="vuelidateOptions.provinceId.error"
                      :insertAddNew="false"
                      :ref="vuelidateOptions.provinceId.ref"
                    />
                  </div>
                  <div class="addRoute__body__left__form__container__item">
                    <a-select-dropdown
                      :label="`City`"
                      :options="options.cities"
                      :value.sync="model.cityId"
                      :error.sync="vuelidateOptions.cityId.error"
                      :insertAddNew="false"
                      :ref="vuelidateOptions.cityId.ref"
                    />
                  </div>
                </div>
                <div class="addRoute__body__left__form__container__item--flex">
                  <div class="addRoute__body__left__form__container__item">
                    <a-select-dropdown
                      :label="`Area`"
                      :options="options.areas"
                      :value.sync="model.areaId"
                      :error.sync="vuelidateOptions.areaId.error"
                      :insertAddNew="false"
                      :ref="vuelidateOptions.areaId.ref"
                    />
                  </div>
                  <div class="addRoute__body__left__form__container__item">
                    <a-input :label="`Zip Code`" :value.sync="model.zipCode" />
                  </div>
                </div>
                <div class="addRoute__body__left__form__container__item--flex">
                  <div class="addRoute__body__left__form__container__item">
                    <a-input :label="`Longitude`" :value.sync="model.longitude" />
                  </div>
                  <div class="addRoute__body__left__form__container__item">
                    <a-input :label="`Latitude`" :value.sync="model.latitude" />
                  </div>
                </div>
              </div>
              <!-- Location Map -->
              <div class="addRoute__body__left__form__container">
                <h1 class="subhead">Location Map (Optional)</h1>
                <div class="imagePreview" v-if="model.billboardLocationContent">
                  <div class="imagePreview__left">
                    <div class="imagePreview__img">
                      <img :src="model.billboardLocationContent.imageUrl" alt />
                    </div>
                    <div class="imagePreview__description">
                      <span class="subhead">{{model.billboardLocationContent.caption}}</span>
                      <span
                        class="micro-font color-green"
                        v-if="model.billboardLocationContent.isSuccess"
                      >Uploaded</span>
                      <span class="micro-font color-pink" v-else>Failed</span>
                    </div>
                  </div>
                  <div class="imagePreview__action">
                    <i @click="cancelImageMap(index)" class="icon-deleted"></i>
                  </div>
                </div>
                <div class="uploadFile">
                  <input
                    type="file"
                    accept=".jpg, .jpeg, .png"
                    @change="getFileImageMap($event)"
                    :ref="`fileUpload`"
                    style="display: none;"
                  />
                  <div class="browse" @click="launchFilePicker">
                    <span class="title">Browse file to upload</span>
                    <span class="description">Allowed file type jpg and png. Maximum size 300Kb</span>
                  </div>
                </div>
              </div>
              <!-- Operating Hours -->
              <div
                class="addRoute__body__left__form__container"
                v-if="model.operatingHours.length > 0"
              >
                <h1 class="subhead">Operating Hours (Optional)</h1>
                <div
                  class="addRoute__body__left__form__container__item--flex"
                  v-for="(day, index) in daysOfWeek"
                  :key="index"
                >
                  <a-checkbox
                    :inputId="index+'_open'"
                    :label="day"
                    :value.sync="model.operatingHours[index].isOpen"
                  />
                  <div class="daily-hours">
                    <div class="hour-wrapper start">
                      <span class="mini-font color-grey">Opening Hours</span>
                      <a-list-dropdown
                        :list="operatingHourOptions"
                        @selected="selectedStart($event, index)"
                        :labelButton="model.operatingHours[index].startLabel?model.operatingHours[index].startLabel:'Unset'"
                      />
                    </div>
                    <div class="arrow">
                      <i class="icon-arrow-forward"></i>
                    </div>
                    <div class="hour-wrapper end">
                      <span class="mini-font color-grey">Closing Hours</span>
                      <a-list-dropdown
                        :list="operatingHourOptions"
                        @selected="selectedEnd($event, index)"
                        :labelButton="model.operatingHours[index].endLabel? model.operatingHours[index].endLabel:'Unset'"
                      />
                    </div>
                  </div>
                  <div class="checkbox-wrapper">
                    <a-checkbox
                      :label="`24 Hours`"
                      :inputId="index+'_24h'"
                      :value.sync="model.operatingHours[index].is24Hours"
                    />
                  </div>
                </div>
              </div>
              <!-- Content Restriction -->
              <div class="addRoute__body__left__form__container">
                <h1 class="subhead">Content Restriction</h1>
                <div class="addRoute__body__left__form__container__item">
                  <adx-input-tag
                    :limit="limit"
                    v-model="model.contentRestriction"
                    :value.sync="model.contentRestriction"
                    :label="`Terms & condition ( use comma to separated )`"
                    :add-tag-on-blur="addTagOnBlur"
                  />
                </div>
              </div>
              <!-- Images -->
              <div class="addRoute__body__left__form__container">
                <h1 class="subhead">Images</h1>
                <div
                  v-for="(image, index) in model.billboardContent"
                  :key="index"
                  class="addRoute__body__left__form__container__images"
                >
                  <div class="addRoute__body__left__form__container__images__image">
                    <div
                      :class="[(vuelidateOptions.billboardContent.error[index].id) ? 'upload-wrapper-warning' : 'upload-wrapper']"
                      :ref="vuelidateOptions.billboardContent.ref.id"
                    >
                      <div class="top">
                        <div class="upload-button">
                          <input
                            type="file"
                            accept="image/*"
                            @change="getFileImage($event, image, index)"
                            :name="`fileUpload`+index"
                            :id="`fileUpload`+index"
                            style="display: none;"
                          />
                          <label :for="`fileUpload`+index" class="button-input">Add Image</label>
                        </div>
                        <div v-if="image.imageUrl" class="file-image">
                          <img :src="image.imageUrl" />
                        </div>
                        <div class="file-name">
                          <span class="image_name">
                            <label>{{image.caption || image.name}}</label>
                            <i
                              v-if="image.caption || image.name"
                              @click="cancelImage(index)"
                              class="adx-ic_cancel"
                            ></i>
                          </span>
                          <div class="image_status" v-if="imageLoadings[index] != null">
                            <span v-if="imageLoadings[index]" class="is_loading">Loading...</span>
                            <span
                              v-if="!imageLoadings[index] && image.isSuccess"
                              class="is_success"
                            >Uploaded</span>
                            <span
                              v-if="!imageLoadings[index] && !image.isSuccess"
                              class="is_error"
                            >Error</span>
                          </div>
                        </div>
                      </div>
                      <div class="bottom">
                        <div>
                          <a-checkbox
                            :label="`Set as featured image`"
                            :valueLabel.sync="image.isFeatured"
                            :value.sync="image.isFeatured"
                            :inputId="index"
                            @buttonClicked="buttonClicked(image)"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="icon-wrapper">
                      <i @click="deleteImages(model.images, index)" class="icon-deleted"></i>
                    </div>
                    
                  </div>
                  <div
                    v-if="vuelidateOptions.billboardContent.error[index].id"
                    class="error-message"
                  >{{vuelidateOptions.billboardContent.error[index].id}}</div>
                </div>
                <div class="line-wrapper">
                  <hr class="line" />
                </div>
                <div class="button">
                  <button @click="addImage(model.images)" class="new">Add new</button>
                </div>
              </div>
              <!-- Placement -->
              <div class="addRoute__body__left__form__placement">
                <h1 class="subhead">Placement</h1>
                <div class="addRoute__body__left__form__placement__items">
                  <table>
                    <thead class="none">
                      <tr>
                        <td class="header subhead">PLACEMENT</td>
                        <td class="header subhead center-title">INIT. QUANTITY</td>
                        <td class="header subhead center-title">ACTIVE</td>
                        <td class="header subhead center-title">PUBLIC</td>
                      </tr>
                    </thead>
                    <tbody v-if="!isLoadingAll && !isEmpty">
                      <tr v-for="(item, index) in this.model.items" :key="index" class="content">
                        <td class="placement subhead">{{item.placements}}</td>
                        <td class="quantity subhead">{{item.quantity}}</td>
                        <td class="check-icon subhead">
                          <span v-if="item.active" class="check">
                            <img src="/img/adxicon/ic-add2.png" alt />
                          </span>
                          <span v-else class="none">-</span>
                        </td>
                        <td class="check-icon subhead">
                          <span v-if="item.public" class="check">
                            <img src="/img/adxicon/ic-add2.png" alt />
                          </span>
                          <span v-else class="none">-</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div class="emptyState" v-if="model.items.length < 1">
                    <a-empty-selection
                      title="No Placement to Show"
                      subtitle="There is no one placement linked to this route"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Right Content -->
          <div class="addRoute__body__right">
            <div class="addRoute__body__right__status__container pic">
              <h1 class="subhead">PIC</h1>
              <div class="dropdown" v-for="(obj, i) in model.pics" :key="i">
                <a-single-search-dropdown
                  :label="`Owner`"
                  :optionsParam="options.users"
                  :value.sync="obj.pic"
                  :size="'small'"
                  :error.sync="vuelidateOptions.pics.error[i].pic"
                  :ref="vuelidateOptions.pics.ref.pic"
                />
              </div>
              <div class="line-wrapper-pic">
                <hr class="line" />
              </div>
              <div class="button-pic">
                <button @click="addPIC" class="new">Add new</button>
              </div>
            </div>
            <div class="button">
              <button class="btn-large primary" @click="save">
                Save
                <a-loading-scnd-white v-if="saveLoading" />
              </button>
            </div>
          </div>
        </div>
        <!-- Modal -->
        <a-modal
          v-if="isShowModalCategories"
          :title="`Add New Categories`"
          @modal-close="toggleModal('category')"
          type="small"
        >
          <div class="addRoute__modal__category" slot="content">
            <a-input
              class="input"
              :label="`Categories Name`"
              :value.sync="categoryModel.newCategory"
              :ref="vuelidateCategoryOptions.newCategory.ref"
              :error.sync="vuelidateCategoryOptions.newCategory.error"
              @keypress.enter.native="submitNew('categoryModel', $event)"
            />
            <div class="buttons">
              <button class="btn-regular secondary" @click="toggleModal('category')">Cancel</button>
              <button class="btn-large primary save" @click="submitNew('categoryModel', $event)">
                Save
                <a-loading-scnd-white v-if="modalLoading" />
              </button>
            </div>
          </div>
        </a-modal>
        <a-modal
          v-if="isShowModalBrand"
          :title="`Add New Brand`"
          @modal-close="toggleModal('brand')"
          type="small"
        >
          <div class="addRoute__modal__category" slot="content">
            <a-input
              class="input"
              :label="`Brand Name`"
              :value.sync="brandModel.newBrand"
              :ref="vuelidateBrandOptions.newBrand.ref"
              :error.sync="vuelidateBrandOptions.newBrand.error"
              @keypress.enter.native="submitNew('brandModel', $event)"
            />
            <div class="buttons">
              <button class="btn-regular secondary" @click="toggleModal('brand')">Cancel</button>
              <button class="btn-large primary save" @click="submitNew('brandModel', $event)">
                Save
                <a-loading-scnd-white v-if="saveLoading" />
              </button>
            </div>
          </div>
        </a-modal>
      </div>
    </template>
    <template v-if="isLoadingAll">
      <div class="container__loadingWrapper">
        <slot name="loading" />
        <a-loading />
      </div>
    </template>
  </div>
</template>	

<script>
import * as validationLib from "@/lib/validation/";
import triggerValidation from "@/lib/triggerValidation";
import _ from "lodash";
import {
  mapListFilter,
  fromArrayKeys,
  fromArrayKeysName
} from "@/lib/transformer";
import { globalMixins } from "@/lib/mixins/globalMixins";
import { mapGetters } from "vuex";
import { restEdge } from "@/api/edgeUrls";
import types from "@/lib/types";
import api from "@/api";
import InputTag from "@/components/Form/InputTag";
import {
  required,
  minLength,
  maxLength,
  alphaNum,
  alpha,
  requiredIf
} from "vuelidate/lib/validators";
import {
  AInput,
  ACheckbox,
  ATextArea,
  ASelectDropdown,
  ASingleSearchDropdown,
  ALoadingPrimary,
  ALoadingSecondary,
  ALoadingSecondaryWhite,
  AEmptySelection,
  AModal,
  AInputTag,
  AListDropdown
} from "ui-kit-v1";

const { helpers, validate } = validationLib;

export default {
  name: "adx-add-route",
  components: {
    "a-modal": AModal,
    "a-loading": ALoadingPrimary,
    "a-loading-scnd-white": ALoadingSecondaryWhite,
    "a-empty-selection": AEmptySelection,
    "a-input": AInput,
    "a-checkbox": ACheckbox,
    "a-textarea": ATextArea,
    "a-select-dropdown": ASelectDropdown,
    "a-single-search-dropdown": ASingleSearchDropdown,
    "a-input-tag": AInputTag,
    "adx-input-tag": InputTag,
    AListDropdown
  },
  mixins: [globalMixins],
  props: {},
  data() {
    return {
      isEdit: false,
      limit: 100,
      placeholder: "Separate tags with comma",
      readOnly: false,
      validate: "",
      addTagOnBlur: true,
      optionPromise: null,
      formPromise: null,
      waypointKey: false,
      isEmpty: false,
      isLoadingAll: false,
      isSaving: true,
      isShowModalCategories: false,
      isShowModalWayPoint: [],
      isShowModalBrand: false,
      modalLoading: false,
      saveLoading: false,
      userInputted: true,
      errorLocation: [],
      imageLoadings: [],
      routeId: null,
      operatingHourOptions: [],
      daysOfWeek: types.days_of_week,
      model: {
        code: null,
        name: null,
        side: null,
        categoryId: null,
        brandId: null,
        description: null,
        address: null,
        provinceId: null,
        cityId: null,
        areaId: null,
        zipCode: null,
        longitude: null,
        latitude: null,
        contentRestriction: [],
        billboardLocationContent: null,
        billboardContent: [
          {
            id: null,
            name: null,
            image: null,
            isFeaturedurl: null
          }
        ],
        pics: [
          {
            pic: null
          }
        ],
        profileId: null,
        items: [],
        operatingHours: []
      },
      brandModel: {
        newBrand: null
      },
      categoryModel: {
        newCategory: null
      },
      waypointModel: {
        newWaypoint: null
      },
      vuelidateOptions: {
        code: {
          field: "code",
          error: null,
          ref: "code"
        },
        name: {
          error: null,
          ref: "name"
        },
        side: {
          error: null,
          ref: "side"
        },
        categoryId: {
          field: "category",
          error: null,
          ref: "categoryId"
        },
        brandId: {
          field: "brand",
          error: null,
          ref: "brandId"
        },
        description: {
          error: null,
          ref: "description"
        },
        address: {
          error: null,
          ref: "address"
        },
        provinceId: {
          field: "province",
          error: null,
          ref: "provinceId"
        },
        cityId: {
          field: "city",
          error: null,
          ref: "cityId"
        },
        areaId: {
          field: "area",
          error: null,
          ref: "areaId"
        },
        billboardContent: {
          // field: 'billboard content',
          error: [{ id: null }],
          ref: {
            id: "id"
          }
        },
        pics: {
          error: [{ pic: null }],
          ref: {
            pic: "pic"
          }
        }
      },
      vuelidateBrandOptions: {
        newBrand: {
          field: "brand",
          error: null,
          ref: "newBrand"
        }
      },
      vuelidateCategoryOptions: {
        newCategory: {
          field: "category",
          error: null,
          ref: "newCategory"
        }
      },
      vuelidateWaypointOptions: {
        newWaypoint: {
          field: "waypoint",
          error: null,
          ref: "newWaypoint"
        }
      },
      options: {
        categories: [],
        users: [],
        brands: [],
        profiles: [],
        provinces: [],
        cities: [],
        areas: []
      }
    };
  },
  validations: {
    model: {
      code: { required, minLength: minLength(3), maxLength: maxLength(50) },
      name: { required, minLength: minLength(3), maxLength: maxLength(50) },
      categoryId: { required },
      brandId: { required },
      address: { required, minLength: minLength(3), maxLength: maxLength(50) },
      provinceId: { required },
      cityId: { required },
      areaId: { required },
      billboardContent: {
        $each: {
          id: { required }
        }
      },
      pics: {
        $each: {
          pic: { required }
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      user: "account",
      token: "token"
    })
  },
  apollo: {},
  watch: {},
  beforeCreate() {},
  async created() {
    this.isLoadingAll = true;
    if (this.$route.params.hasOwnProperty("id")) {
      this.isEdit = true;
      this.routeId = this.$route.params.id;
    } else {
      this.isEdit = false;
      this.isLoadingAll = false;
    }

    await this.getFormOptions();
    this.getHours();

    for (let index = 0; index < 7; index++) {
      this.model.operatingHours.push({
        value: null,
        start: null,
        end: null,
        is24Hours: null,
        isOpen: null
      });
    }

    if (this.routeId) await this.getFormData();
  },
  beforeMount() {},
  async mounted() {},
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    submitNew(type, event, index = null) {
      if (type === "categoryModel") {
        event.key != "enter"
          ? this.createNewOption(
              type,
              this.categoryModel.newCategory,
              this.vuelidateCategoryOptions,
              "createCategory"
            )
          : this.createNewOption(
              "categoryModel",
              event.target.value,
              this.vuelidateCategoryOptions,
              "createCategory"
            );
      } else if (type === "waypointModel") {
        event.key != "enter"
          ? this.createNewOption(
              type,
              this.waypointModel.newWaypoint,
              this.vuelidateWaypointOptions,
              "createInterest",
              index
            )
          : this.createNewOption(
              "waypointModel",
              event.target.value,
              this.vuelidateWaypointOptions,
              "createInterest",
              index
            );
      } else if (type === "brandModel") {
        event.key != "enter"
          ? this.createNewOption(
              type,
              this.brandModel.newBrand,
              this.vuelidateBrandOptions,
              "airlineNewBrand"
            )
          : this.createNewOption(
              "brandModel",
              event.target.value,
              this.vuelidateBrandOptions,
              "airlineNewBrand"
            );
      }
    },
    async createNewOption(type, value, options, url, index = null) {
      // this.$v.$touch();

      // if (this.$v[type].$invalid) {
      //   const {
      //     key,
      //     message,
      //     element,
      //     collection
      //   } = helpers.vuelidateValidationHelper(
      //     this.$v[type],
      //     options,
      //     this.$refs
      //   );
      //   options[key].error = message;
      //   if (element && type !== "waypointModel") {
      //     this.$nextTick(function() {
      //       element.scrollIntoView();
      //     });
      //   }
      // } else {
        const { data, status, statusText } = await api.post(
          restEdge[url],
          { title: value },
          { needToken: true, useRestEdge: true }
        );

        if (status == 200) {
          this.modalLoading = false;
          let element;

          if (type === "categoryModel") {
            this.options.categories.push({
              id: data.id,
              title: data.title,
              label: data.title,
              value: data.id
            });
            this.isShowModalCategories = false;
            element = this.$refs.category.$el;
            this.$nextTick(function() {
              this.model.category = data.id;
              element.scrollIntoView();
            });
          } else if (type === "brandModel") {
            this.options.brands.push({
              id: data.id,
              title: data.title,
              label: data.title,
              value: data.id
            });
            this.isShowModalBrand = false;
            element = this.$refs.brand.$el;
            this.$nextTick(function() {
              this.model.brand = data.id;
              element.scrollIntoView();
            });
          } else if (type === "waypointModel") {
            this.isShowModalCategories = false;
            this.isShowModalWayPoint[index] = false;
            this.options.waypoints.push({
              id: data.id,
              title: data.title,
              label: data.title,
              value: data.id
            });
            element = this.$refs.waypoint[index].$el;
            this.$nextTick(function() {
              this.model.waypointLocation[index].waypoint = data.id;
              element.scrollIntoView();
            });
          }
        } else {
          this.showNotificationAlert("Error", statusText, "danger");
        }
      // }
    },
    async saveKMLFile() {
      this.kmlLoading = true;

      let formData = new FormData();
      formData.append("file", this.model.kmlFileData);
      formData.append("name", this.model.kmlFileData.name);
      const response = await api.post(restEdge.uploadFile, formData, {
        needToken: true,
        useRestEdge: true,
        headers: { "Content-Type": "multipart/form-data" }
      });

      this.kmlLoading = false;
      if (response.status == 200) {
        this.kmlSuccess = true;
        this.model.kmlFileId = parseInt(response.data.id);
      } else {
        this.kmlSuccess = false;
        this.showNotificationAlert("Error", "KML failed to save", "danger");
      }
    },
    addWayPoint() {
      this.model.waypointLocation.push({ location: null, waypoint: null });
      this.vuelidateOptions.waypointLocation.error.push({
        location: null,
        waypoint: null
      });
      this.isShowModalWayPoint.push(false);
    },
    deleteWayPoint(index) {
      if (this.model.waypointLocation.length > 1) {
        this.model.waypointLocation.splice(index, 1);
        this.isShowModalWayPoint.splice(index, 1);
      } else {
        this.showNotificationAlert(
          "Delete Error",
          "Oops data can not be deleted!",
          "danger"
        );
      }
    },
    cancelFile() {
      this.model.kmlFileName = null;
      this.kmlLoading = null;
    },
    async getFile(event) {
      let input = event.target;
      if (input.files && input.files[0]) {
        let reader = new FileReader();
        reader.onload = e => {
          this.model.kmlFile = e.target.result;
        };
        reader.readAsDataURL(input.files[0]);
        this.model.kmlFileName = input.files[0].name;
        this.model.kmlFileData = input.files[0];
        await this.saveKMLFile();
      }
    },
    launchFilePicker() {
      this.$refs.fileUpload.click();
    },
    toggleModal(type) {
      if (type === "category") {
        this.isShowModalCategories = !this.isShowModalCategories;
        this.categoryModel.newCategory = null;
        this.vuelidateCategoryOptions.newCategory.error = null;
      } else if (type === "brand") {
        this.isShowModalBrand = !this.isShowModalBrand;
        this.brandModel.newBrand = null;
        this.vuelidateBrandOptions.newBrand.error = null;
      }
    },
    getFileImage(event, image, index) {
      let input = event.target;
      if (input.files && input.files[0]) {
        let reader = new FileReader();
        let validated_data = this.validateImageFile(input.files[0]);
        if (!validated_data.is_valid) {
          this.showNotificationAlert("Error", validated_data.message, "danger");
        } else {
          reader.onload = e => {
            image.url = e.target.result;
          };
          reader.readAsDataURL(input.files[0]);
          image.name = input.files[0].name;
          image.image = input.files[0];
          this.saveImage(input.files[0], image, index);
        }
      }
    },
    getFileImageMap(event) {
      let input = event.target;
      if (input.files && input.files[0]) {
        let reader = new FileReader();
        let validated_data = this.validateImageFile(input.files[0]);
        if (!validated_data.is_valid) {
          this.showNotificationAlert("Error", validated_data.message, "danger");
        } else {
          this.saveImageMap(input.files[0]);
        }
      }
    },
    async saveImage(fileData, image, index) {
      image.loading = true;
      this.$set(this.imageLoadings, index, true);
      let formData = new FormData();
      formData.append("file", fileData);
      formData.append("name", fileData.name);
      const result = await api.post(restEdge.uploadBillboardContent, formData, {
        needToken: true,
        useRestEdge: true,
        headers: {
          "Content-Type": "multipart/form-data"
        }
      });
      await this.$nextTick();
      this.$set(this.imageLoadings, index, false);
      if (!result.errors) {
        image.isSuccess = true;
        image.id = parseInt(result.data.id);
        this.model.billboardContent[index] = result.data;
        this.model.billboardContent[index].isSuccess = true;
        this.model.billboardContent[index].loading = true;
        this.model.imageIds.push({ id: parseInt(result.data.id) });
      } else {
        image.isSuccess = false;
      }
    },
    cancelImage(index) {
      this.model.images[index].id = null;
      this.model.images[index].name = null;
      this.model.images[index].image = null;
      this.model.images[index].isFeatured = null;
      this.model.images[index].url = null;
      this.$set(this.imageLoadings, index, null);
    },
    cancelImageMap() {
      this.model.billboardLocationContent = null
    },
    validateImageFile(file) {
      let maxSize = 2000000; // 2 MB
      let data = { is_valid: true };
      if (/image/.test(file.type)) {
        let image_ext_patt = new RegExp(/.jpg|.jpeg|.png/);
        if (!image_ext_patt.test(file.name.toLowerCase())) {
          data.is_valid = false;
          data.message = "Unsupported file type";
          return data;
        }
      } else {
        data.is_valid = false;
        data.message = "Unsupported file type";
        return data;
      }
      if (file.size > maxSize) {
        data.is_valid = false;
        data.message = `File too large.`;
        return data;
      }
      const filename = file.name.split(".")[0];
      if (filename.length > 100) {
        data.is_valid = false;
        data.message = "File name is too long. Maximum size 100 character";
        return data;
      }

      if (filename.includes("/")) {
        data.is_valid = false;
        data.message = "File name has forbidden character";
        return data;
      }
      return data;
    },
    async saveImageMap(fileData) {
      let formData = new FormData();
      formData.append("file", fileData);
      formData.append("name", fileData.name);
      const result = await api.post(
        restEdge.uploadBillboardLocationContent,
        formData,
        {
          needToken: true,
          useRestEdge: true,
          headers: {
            "Content-Type": "multipart/form-data"
          }
        }
      );

      if (!result.errors) {
        this.model.billboardLocationContent = {
          id: result.data.id,
          imageUrl: result.data.imageUrl,
          caption: result.data.name,
          isSuccess: true
        };
      } else {
        this.model.billboardLocationContent = {
          isSuccess: false
        };
      }
    },
    addImage() {
      this.model.billboardContent.push({
        id: null,
        name: null,
        image: null,
        isFeaturedurl: null
      });
      this.vuelidateOptions.billboardContent.error.push({ id: null });
    },
    deleteImages(image, index) {
      this.model.billboardContent.splice(index, 1);
      this.imageLoadings.splice(index, 1);
    },
    async save() {
      this.$v.$touch();

      if (this.$v.model.$invalid) {
        const {
          key,
          message,
          element,
          collection
        } = helpers.vuelidateValidationHelper(
          this.$v.model,
          this.vuelidateOptions,
          this.$refs
        );
        if (collection) {
          this.vuelidateOptions[key].error[collection.index][
            collection.collectionKey
          ] = message;
        } else {
          this.vuelidateOptions[key].error = message;
        }
        if (typeof element[0] == "undefined") {
          this.$nextTick(function() {
            element.scrollIntoView();
          });
        } else {
          this.$nextTick(function() {
            if (element[0].hasOwnProperty("$el")) {
              element[0].$el.scrollIntoView();
            } else {
              element[0].scrollIntoView();
            }
          });
        }
      } else {
        this.saveLoading = true;

        const OH = _.compact(
          this.model.operatingHours.map((oh, index) => {
            if (oh.isOpen) {
              return {
                dayOfWeek: index,
                startHour: oh.isOpen ? oh.start : null,
                startMinute: 0,
                endHour: oh.isOpen ? oh.end : null,
                endMinute: 0,
                allTime: oh.is24Hours ? oh.is24Hours : false
              };
            }
          })
        );

        const CONTENT = await this.model.billboardContent.map(c => {
          return {
            id: c.createdAt ? undefined : c.id,
            isFeatured: c.isFeatured,
            caption: c.name || c.caption,
            imageUrl: c.imageUrl,
            isPrimary: c.isFeatured,
            is360: c.is360
          };
        });

        const LOCATIONCONTENT = {
          id: this.model.billboardLocationContent.createdAt ? this.model.billboardLocationContent.id : null,
          imageUrl: this.model.billboardLocationContent.imageUrl,
          caption: this.model.billboardLocationContent.caption,
        }

        const data = {
          name: this.model.name,
          categoryId: this.model.categoryId,
          brandId: this.model.brandId,
          description: this.model.description,
          address: this.model.address,
          provinceId: this.model.provinceId,
          cityId: this.model.cityId,
          areaId: this.model.areaId,
          zipCode: parseInt(this.model.zipCode),
          longitude: parseInt(this.model.longitude),
          latitude: parseInt(this.model.latitude),
          contentRestriction: this.model.contentRestriction,
          billboardContent: CONTENT,
          pic: this.model.pics.length
            ? this.model.pics.map(pic => pic.pic)
            : [],
          profileId: this.model.profileId,
          operatingHours: OH,
          side: this.model.side,
          code: this.model.code,
          billboardLocationContent: LOCATIONCONTENT
        };

        let response;

        if (!this.isEdit) {
          response = await api.post(restEdge.createBillboardLocation, data, {
            needToken: true,
            useRestEdge: true
          });
        } else {
          response = await api.put(
            restEdge.editBillboardLocation(this.$route.params.id),
            data,
            {
              needToken: true,
              useRestEdge: true
            }
          );
        }

        this.saveLoading = false;

        if (response.status === 200) {
          this.showNotificationAlert(
            "Success",
            "Data successfully saved!",
            "success"
          );
          this.$router.push({ name: "billboardlocation" });
        } else {
          this.showNotificationAlert("Error", "Data failed to save", "danger");
        }
      }
    },
    async getFormOptions() {
      const { data, status, statusText } = await api.get(
        restEdge.getFormBillboardLocationdata,
        {
          needToken: true,
          useRestEdge: true
        }
      );

      if (status === 200) {
        const { brands, profiles, categories } = fromArrayKeys(data);
        const { cities, provinces, areas } = fromArrayKeysName(data);
        this.options.categories = categories;
        this.options.profiles = profiles;
        this.options.brands = brands;
        this.options.cities = cities;
        this.options.provinces = provinces;
        this.options.areas = areas;
        this.options.users = await data.emails.map(user => ({
          id: parseInt(user.id),
          label: user.email,
          title: user.email,
          value: user.id
        }));
      } else {
        this.showNotificationAlert("Error", statusText, "danger");
      }
    },
    async getFormData() {
      this.isLoadingAll = true;
      const { data, status, statusText } = await api.get(
        restEdge.getBillboardLocationById(this.routeId),
        {
          needToken: true,
          useRestEdge: true
        }
      );

      if (status === 200) {
        this.model.code = data.code;
        this.model.name = data.name;
        this.model.categoryId = data.categoryId;
        this.model.brandId = data.brandId;
        this.model.description = data.description;
        this.model.address = data.address;
        this.model.provinceId = data.provinceId;
        this.model.cityId = data.cityId;
        this.model.areaId = data.areaId;
        this.model.zipCode = data.zipCode;
        this.model.longitude = data.longitude;
        this.model.latitude = data.latitude;
        this.model.contentRestriction = data.contentRestriction;
        this.model.billboardContent = data.billboardContent;
        this.model.pics = data.pic.map(x => {
          this.vuelidateOptions.pics.error.push({ pic: null });
          return { pic: x.id };
        });
        this.model.profileId = data.profileId;
        this.model.side = data.side;
        this.model.billboardLocationContent = data.billboardLocationContent.length > 0 ? {
          imageUrl: data.billboardLocationContent[0].imageUrl,
          caption: data.billboardLocationContent[0].caption,
          isSuccess: true,
          id: data.billboardLocationContent[0].id
        } : null

        data.operatingHours.map(oh => {
          this.model.operatingHours[oh.dayOfWeek].value = oh.dayOfWeek;
          this.model.operatingHours[oh.dayOfWeek].start = oh.startHour;
          this.model.operatingHours[oh.dayOfWeek].end = oh.endHour;
          this.model.operatingHours[oh.dayOfWeek].is24Hours = oh.allTime;
          this.model.operatingHours[oh.dayOfWeek].isOpen = true;
          this.model.operatingHours[oh.dayOfWeek].startLabel = oh.startHour
            ? oh.startHour.length > 1
              ? oh.startHour + ":00"
              : "0" + oh.startHour + ":00"
            : null;
          this.model.operatingHours[oh.dayOfWeek].endLabel = oh.endHour
            ? oh.endHour.length > 1
              ? oh.endHour + ":00"
              : "0" + oh.endHour + ":00"
            : null;
        });

        this.isLoadingAll = false;
      } else {
        this.showNotificationAlert("Error", statusText, "danger");
      }
    },
    buttonClicked(image) {
      this.model.images.map(img => {
        if (img.id !== image.id) img.isFeatured = false;
      });
    },
    showWaypoint(event, index) {
      let wayPointId = event && event.item ? event.item.id : null;
      if (wayPointId === 0 || !wayPointId) {
        let val = !this.isShowModalWayPoint[index];
        this.$set(this.isShowModalWayPoint, index, val);
      } else {
        this.isShowModalWayPoint[index] = false;
      }
      this.waypointModel.newWaypoint = null;
      this.vuelidateWaypointOptions.newWaypoint.error = null;
    },
    getHours() {
      let file = `/static/data/hours.json`;
      (async () => {
        let request = await fetch(new Request(file));
        let data = await request.json();

        data.hours.map(hour => {
          this.operatingHourOptions.push({
            id: hour.id,
            label: hour.label,
            value: hour.id
          });
        });
      })();
    },
    selectedStart(a, b) {
      this.model.operatingHours[b].start = a.value;
    },
    selectedEnd(a, b) {
      this.model.operatingHours[b].end = a.value;
    },
    addPIC() {
      this.model.pics.push({ pic: null });
    }
  }
};
</script>

<style lang='scss' scoped>
@import "./index.scss";
@import "~@/styles/variables";
@import "~@/styles/mixins";

.addRoute {
  &__body {
    &__left {
      &__form {
        &__size {
          .selectDropdown {
            input {
              padding-top: 0;
            }

            .popup {
              &__input {
                max-width: 100%;
                margin-left: 48px;
              }
            }
          }
        }
      }
    }
  }

  .waypointWrapper {
    display: flex;
  }

  input {
    min-height: 62px;
  }

  .selectDropdown {
    .popup {
      max-height: 300px;
      overflow-y: auto;
    }
    .select {
      input {
        min-height: 62px;
      }
    }
  }

  .btn-regular {
    min-width: 32px;
    height: 45px;

    &.teal {
      background-color: $white;
      border: solid 1px $pale-grey;
      color: unset;
    }
  }

  .title.large-font {
    font-size: 24px;
  }
}
</style>

<style lang="scss">
.addRoute {
  .input-tag {
    max-height: 24px;
  }

  .teal {
    background-color: unset;
    border: unset;
    color: #262626;
    &:hover {
      background-color: unset;
      border: unset;
    }
  }
}

.daily-hours .dropdown .btn-regular {
  border: unset;
}

.dropdown {
  .btn-regular {
    left: -14px;
    border: unset;
    &:hover {
      background-color: unset;
      border: unset;
    }
  }
}
</style>
